import { getAlert } from "./SamuiUtils";
import { getDataWithComp } from "./SamuiUtils";

/** เส้นทางสุดท้าย .../api/reports/thunderbee/receipt — รองรับทั้ง REACT_APP_API_REPORT_URL แบบ .../reports และ .../reports/thunderbee */
export function receiptReportHref(reportBase, reportPathSegment) {
    const base = (reportBase || "").replace(/\/+$/, "");
    let segment = reportPathSegment || "receipt";
    segment = String(segment).replace(/^\/+/, "");
    if (segment.toLowerCase().startsWith("thunderbee/")) {
        segment = segment.slice("thunderbee/".length);
    }
    if (/\/thunderbee$/i.test(base)) {
        return `${base}/${segment}`;
    }
    return `${base}/thunderbee/${segment}`;
}

// รายงานใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษี จาก CT_Pay
export function openReceiptReportByPayRow(payRow) {
    try {
        const reportBase = process.env.REACT_APP_API_REPORT_URL;
        const ctPayId = payRow?.CT_Pay_Id;
        if (!reportBase || !ctPayId) {
            getAlert("FAILED", "ไม่พบข้อมูลสำหรับพิมพ์รายงาน");
            return;
        }

        const paidAmount = Number(payRow?.Paid || 0);
        const hasVat = payRow?.Is_VAT === true || payRow?.Is_VAT === 1;
        // 1=ใบแจ้งหนี้ (ยังไม่ชำระ), 2=ใบเสร็จรับเงิน (ชำระแล้วไม่มี VAT), 3=ใบกำกับภาษี (ชำระแล้วมี VAT)
        const pCondition = paidAmount <= 0 ? 1 : hasVat ? 3 : 2;

        // Crystal: route thunderbee/receipt — query P_DOC_ID + P_CONDITION (ค่า P_DOC_ID = CT_Pay_Id)
        const reportPathSegment =
            process.env.REACT_APP_RECEIPT_REPORT_NAME || "receipt";
        const customReceiptUrl = process.env.REACT_APP_RECEIPT_REPORT_URL;
        const baseUrl =
            customReceiptUrl || receiptReportHref(reportBase, reportPathSegment);
        const url =
            `${baseUrl}` +
            `?P_DOC_ID=${encodeURIComponent(ctPayId)}` +
            `&P_CONDITION=${encodeURIComponent(pCondition)}`;
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
    } catch (error) {
        console.error("openReceiptReportByPayRow error:", error);
        getAlert("FAILED", error.message || error);
    }
}

// เรียกรายงาน Crystal Report
export async function getReport(reportName, docNo) {
    try {
        if (!reportName || !docNo) {
            getAlert("FAILED", "ไม่สามารถเปิดรายงานได้ กรุณาลองใหม่อีกครั้ง");
            return;
        }

        // รายงานสรุปเอกสารคลัง (รองรับ payload object)
        if (reportName === "SUM_WHDOC_1" || reportName === "SUM_WHDOC_2" || reportName === "SUM_WHDOC_3") {
            const pl = (docNo && typeof docNo === "object") ? docNo : null;
            const pDocId = pl?.WHDoc_Id?.toString().trim();
            const pCondition = pl?.Date || "";
            const pCondition2 = pl?.selectedWarehouseFrom || "ทั้งหมด";
            const pCondition3 = reportName === "SUM_WHDOC_2"
                ? ""
                : (Array.isArray(pl?.whDocRemarks)
                    ? (pl.whDocRemarks.length > 1 ? "ทั้งหมด" : (pl.whDocRemarks[0] ?? "-"))
                    : (pl?.whDocRemarks ?? "-"));
            const pCondition4 = pl?.acc || "system";

            if (!pDocId) {
                getAlert("FAILED", `กรุณาเลือกรายการเอกสารสำหรับรายงานสรุป (${reportName})`);
                return;
            }

            const link = document.createElement("a");
            link.href =
                `${process.env.REACT_APP_API_REPORT_URL}/${reportName}` +
                `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
                `&P_CONDITION=${encodeURIComponent(pCondition)}` +
                `&P_CONDITION2=${encodeURIComponent(pCondition2)}` +
                `&P_CONDITION3=${encodeURIComponent(pCondition3)}` +
                `&P_CONDITION4=${encodeURIComponent(pCondition4)}`;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.click();
            return;
        }

        let tableMap = {
            po: { table: 'PO_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                                // ใบสั่งซื้อ
            rec: { table: 'REC_H', filterColumn: 'Rec_No', resultColumn: 'Rec_Id' },                              // ใบรับสินค้า
            pay: { table: 'PAY_H', filterColumn: 'Pay_No', resultColumn: 'Pay_Id' },                              // ใบสำคัญจ่าย
            qt: { table: 'QT_H', filterColumn: 'Doc_Id', resultColumn: 'Doc_Id' },                                // ใบเสนอราคา
            WHDOC: { table: 'WHDoc_H', filterColumn: 'WHDoc_No', resultColumn: 'WHDoc_Id', typeColumn: 'WHDoc_Type' }, // เอกสารคลัง
            contract: { table: 'CT_H', filterColumn: 'Doc_Id', resultColumn: 'Doc_Id' },                          // ใบสัญญา
            receipt_report: { table: 'CT_Pay', filterColumn: 'CT_Pay_Id', resultColumn: 'CT_Pay_Id' },            // ใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษี (Receipt_report)
            method: { table: 'Tb_Set_Service', filterColumn: 'Service_Id', resultColumn: 'Service_Id' },          // ใบขออนุมัติวิธีการ
            TAX: { table: 'API_1702_WTAX_D', filterColumn: 'WTAX_Id', resultColumn: 'WTAX_Id' },                  // หนังสือหัก ณ ที่จ่าย
        };

        const reportConfig = tableMap[reportName];
        if (!reportConfig) {
            getAlert("FAILED", "ไม่พบรายงานที่ต้องการ");
            return;
        }

        let pDocId = null;
        let pWhere = null;

        if (reportName === 'tax' || reportName === 'TAX') {
            pDocId = docNo;
        } else if (reportName === "receipt_report") {
            const payId =
                typeof docNo === "object"
                    ? Number(docNo?.CT_Pay_Id)
                    : Number(docNo);
            if (!payId || Number.isNaN(payId)) {
                getAlert("FAILED", "ไม่พบ CT_Pay_Id สำหรับพิมพ์รายงาน");
                return;
            }
            const paidAmount = Number(
                typeof docNo === "object" ? docNo?.Paid || 0 : 0
            );
            const hasVat =
                typeof docNo === "object" &&
                (docNo?.Is_VAT === true || docNo?.Is_VAT === 1);
            const pCondition = paidAmount <= 0 ? 1 : hasVat ? 3 : 2;
            const reportPathSegment =
                process.env.REACT_APP_RECEIPT_REPORT_NAME || "receipt";
            const customReceiptUrl = process.env.REACT_APP_RECEIPT_REPORT_URL;
            const baseUrl =
                customReceiptUrl ||
                receiptReportHref(
                    process.env.REACT_APP_API_REPORT_URL,
                    reportPathSegment
                );
            const link = document.createElement("a");
            link.href =
                `${baseUrl}` +
                `?P_DOC_ID=${encodeURIComponent(payId)}` +
                `&P_CONDITION=${encodeURIComponent(pCondition)}`;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.click();
            return;
        } else if (reportName === 'income_a') {
            pDocId = 1;
            pWhere = docNo;
        } else if (reportName === 'WHDOC') {
            const whDocNo = typeof docNo === "object" ? docNo?.WHDoc_No : docNo;
            if (!whDocNo) {
                getAlert("FAILED", "ไม่พบเลขเอกสารที่ต้องการพิมพ์");
                return;
            }

            // ใช้ flow เดิมแบบ PBPOS: resolve จาก WHDoc_No -> WHDoc_Id + WHDoc_Type
            const result = await getDataWithComp("WHDoc_H", `AND WHDoc_No = '${whDocNo}'`);
            const pDocId = result?.[0]?.WHDoc_Id;
            if (!pDocId) {
                getAlert("FAILED", "ไม่พบข้อมูลที่ต้องการ");
                return;
            }
            const pCondition = result?.[0]?.WHDoc_Type || "1";

            const link = document.createElement('a');
            link.href =
                `${process.env.REACT_APP_API_REPORT_URL}/WHDOC` +
                `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
                `&P_CONDITION=${encodeURIComponent(pCondition)}`;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.click();
            return;
        } else {
            const { table, filterColumn, resultColumn } = reportConfig;
            const findDocId = await getDataWithComp(table, `AND ${filterColumn} = '${docNo}'`);
            pDocId = findDocId[0]?.[resultColumn];
            
            // ตรวจสอบสถานะยกเลิก (13) สำหรับเอกสารจัดซื้อ
            if (findDocId[0]) {
                const doc = findDocId[0];
                let isCancelled = false;
                
                if (reportName === 'po' && doc.Doc_Status === 13) {
                    isCancelled = true;
                } else if (reportName === 'rec' && doc.Rec_Status === 13) {
                    isCancelled = true;
                } else if (reportName === 'pay' && doc.Pay_Status === 13) {
                    isCancelled = true;
                }
                
                if (isCancelled) {
                    getAlert("FAILED", "ไม่สามารถพิมพ์รายงานได้ เนื่องจากเอกสารถูกยกเลิกแล้ว");
                    return;
                }
            }
        }

        if (!pDocId) {
            getAlert("FAILED", "ไม่พบข้อมูลที่ต้องการ");
            return;
        }

        const link = document.createElement('a');

        if (reportName === 'bi1' || reportName === 'bi2') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/bi?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'bi1' ? 'ต้นฉบับ' : 'สำเนา'}`;
        } else if (reportName === 'inv1' || reportName === 'inv2') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${localStorage.getItem('company') === '1' ? 'inv_water' : 'inv_ice'}?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'inv1' ? '1' : '2'}`;
        } else if (reportName === 'inv1_so' || reportName === 'inv2_so') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${localStorage.getItem('company') === '1' ? 'inv_water' : 'inv_ice_so'}?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'inv1_so' ? '1' : '2'}`;
        } else if (reportName === 'inv1_bi' || reportName === 'inv2_bi') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${localStorage.getItem('company') === '1' ? 'inv_water' : 'inv_ice_bi'}?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'inv1_bi' ? '1' : '2'}`;
        } else if (reportName === 'income_a') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${reportName}?P_DOC_ID=${pDocId}&P_CONDITION=${pWhere}`;
        } else if (reportName === 'qt') {
            const qtBase = process.env.REACT_APP_QT_REPORT_URL
                || `${process.env.REACT_APP_API_REPORT_URL}/qt`;
            link.href = `${qtBase}?P_DOC_ID=${pDocId}&P_CONDITION=ต้นฉบับ`;
        } else {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${reportName}?P_DOC_ID=${pDocId}&P_CONDITION=ต้นฉบับ`;
        }

        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
    } catch (error) {
        console.error("Error fetching data:", error);
        getAlert("FAILED", error.message || error);
    }
};
